<template>
  <div class="newArticle">
    <div class="breadcrumb">
      内容管理 >
      <span v-if="edit === false">新增</span>
      <span v-if="edit !== false">编辑</span>

      <el-button class="right_f" type="primary" @click="cancel">取消</el-button>
      <el-button class="right_f" type="primary" @click="save"
        >保存为草稿</el-button
      >
      <el-button class="right_f" type="primary" @click="issue"
        >保存并发布</el-button
      >
      <el-button class="right_f" type="primary" @click="preview"
        >预览</el-button
      >
    </div>

    <div class="articleDetail">
      <el-form
        ref="articleForm"
        :rules="rules"
        :model="articleForm"
        label-width="110px"
      >
        <el-form-item>
          <el-checkbox class="containVideo" v-model="articleForm.containVideo">
            内容包含视频
          </el-checkbox>
        </el-form-item>

        <el-form-item label="封面图片">
          <el-upload
            :action="actionUrl"
            :with-credentials="true"
            accept="image/*"
            name="uploadFile"
            type="drag"
            :thumbnail-mode="true"
            :on-error="handleError"
            :on-success="handleSuccess"
          >
            <i class="el-icon-upload"></i>
            <div class="el-dragger__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">图片规格650*350</div>
          </el-upload>
        </el-form-item>

        <el-form-item label="列表图片">
          <el-upload
            :action="actionUrl"
            :with-credentials="true"
            accept="image/*"
            name="uploadFile"
            type="drag"
            :thumbnail-mode="true"
            :on-error="handleError"
            :on-success="uploadSuccess"
          >
            <i class="el-icon-upload"></i>
            <div class="el-dragger__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">图片规格650*350</div>
          </el-upload>
        </el-form-item>

        <el-form-item label="标题" class="articleTitle" prop="title">
          <el-input
            v-model="articleForm.title"
            placeholder="请填写正确的标题，不超过50个字符"
          ></el-input>
        </el-form-item>

        <el-form-item label="摘要" class="articleAbstract" prop="abstract">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 5 }"
            placeholder="不超过100个字符"
            v-model="articleForm.abstract"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="作者" class="articleAuthor" prop="phone">
          <el-input
            v-model="articleForm.phone"
            placeholder="请输入手机号"
            style="display: inline-block"
            @blur="selectAuthor()"
          ></el-input
          >{{ articleForm.authorInfo }}
        </el-form-item>

        <el-form-item label="类别" class="articleType" prop="type">
          <el-select v-model="articleForm.type">
            <el-option
              v-for="item in categories"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <select-school
          :schObj="articleForm.schObj"
          @changeVal="getVal"
        ></select-school>
        <el-form-item>
          <el-checkbox
            class="radio"
            :disabled="articleForm.isPublished"
            v-model="articleForm.ifNotice"
            >首次发布，向所有用户发送更新通知</el-checkbox
          >
        </el-form-item>

        <el-form-item label="内容" class="articleContent" prop="content">
          <editor
            ref="myTextEditor"
            :fileName="'uploadFile'"
            :canCrop="canCrop"
            :uploadUrl="actionUrl"
            v-model="articleForm.content"
          ></editor>
        </el-form-item>
      </el-form>

      <el-dialog
        title="文章预览"
        v-model="dialogFormVisible"
        :modal-append-to-body="false"
      >
        <div style="text-align: center">
          <canvas id="canvas"></canvas>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogFormVisible = false"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import QRCode from "qrcode";
import { quillEditor } from "vue-quill-editor";
import editor from "../about/Quilleditor.vue";
import selectSchool from "../../common/selectSch.vue";

export default {
  data() {
    return {
      actionUrl:
        this.$util.domain +
        "/adminapi/v1/basicTools/upload/one?uploadImageType=4",
      dialogFormVisible: true,
      canCrop: false,
      cssString:
        '<html><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"><style>body{font-family:"PingFang";}img{width:100%;}.ql-align-right{text-align: right;}.ql-align-center{text-align: center;}.ql-align-left{text-align: left;}.ql-video{width:300px;height:86px;}p{margin-bottom:0px;margin-top:0px}</style><body>',
      cssStringEnd: "</body></html>",
      edit: false,
      newsId: null,
      categories: [],
      imgUrl: "",
      listImage: "",
      editorOption: {},
      articleForm: {
        title: "",
        abstract: "",
        phone: "",
        author: "95斤同学",
        authorInfo: "",
        authorUid: "",
        htmlUrl: "",
        type: "",
        content: "",
        schObj: {
          applicableCampus: "0",
          shieldedSchools: [],
          openedSchools: [],
        },
        isPublished: false, //是否发表过
        ifNotice: false, //是否需要发送通知
        containVideo: false, //是否包含视频
      },

      rules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          { min: 1, max: 50, message: "不超过50个字符", trigger: "blur" },
        ],
        abstract: [
          { required: true, message: "请输入摘要", trigger: "blur" },
          { min: 1, max: 50, message: "不超过50个字符", trigger: "blur" },
        ],
        type: [
          { required: true, message: "请选择文章类别", trigger: "change" },
        ],
        content: [
          { required: true, message: "请输入文章内容", trigger: "blur" },
        ],
      },
    };
  },
  computed: mapState({ user: (state) => state.user }),
  components: { quillEditor, editor, selectSchool },
  mounted() {
    //获取文章全部类别
    this.getClasses();
    this.dialogFormVisible = false;
    this.$nextTick(() => {
      this.qrcode("www.baidu.com");
    });

    let url = window.location.href;

    if (url.indexOf("?") !== -1) {
      this.edit = true;
      let newsId = this.$util.getUrlParam("newsId");
      this.newsId = newsId;
      this.getNewDetail(newsId);
    }
  },

  methods: {
    ...mapActions(["SIGNOUT"]),

    onEditorChange({ editor, html, text }) {
      this.articleForm.content = html;
    },
    //获取子组件传递的参数
    getVal(res) {
      this.articleForm.schObj = res;
    },
    /**
     * 获取文章类别
     **/
    getClasses() {
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v1/operate/news/categories",
      })
        .then((response) => {
          if (response.data.error === 10000) {
            let categoryList = response.data.data;

            this.categories = [];

            for (let i = 0; i < categoryList.length; i++) {
              let label = categoryList[i].categoryName;
              let value = categoryList[i].id.toString();

              this.categories.push({
                label: label,
                value: value,
              });
            }
          }
        })
        .catch((response) => {
          this.$util.errorMsg("获取文章类别失败");
        });
    },

    /**
     * 取消
     **/
    cancel() {
      window.history.go(-1);
    },

    //保存为草稿或者发布回调
    cbAction(status) {
      if (this.edit) {
        this.editNews(status);
      } else {
        this.add(status);
      }
    },
    /**
     * 保存并发布
     *
     **/
    issue(ev) {
      if (
        this.articleForm.applicableCampus == "1" &&
        this.articleForm.openedSchools.length == 0
      ) {
        this.$util.errorMsg("请添加应用学校");
        return;
      }

      this.$refs.articleForm.validate((valid) => {
        if (valid) {
          if (!this.articleForm.isPublished) {
            if (this.articleForm.ifNotice) {
              this.$confirm(
                "将向所有用户发布更新通知，您确定保存并发布吗？",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }
              ).then(() => {
                this.cbAction(2);
              });
            } else {
              this.$confirm(
                "本次发布将无更新通知，您确定保存并发布吗？",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }
              ).then(() => {
                this.cbAction(2);
              });
            }
          } else {
            this.$confirm(
              "确定要发布吗？发布后该篇会变成‘已发布’状态，且用户端将看到该篇内容",
              "发布",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            ).then(() => {
              this.cbAction(2);
            });
          }
        } else {
          console.log("error submit");
        }
      });
    },
    /**
     * 保存为草稿
     **/
    save() {
      if (
        this.articleForm.applicableCampus == "1" &&
        this.articleForm.openedSchools.length == 0
      ) {
        this.$util.errorMsg("请添加应用学校");
        return;
      }

      if (!this.articleForm.isPublished) {
        if (this.articleForm.ifNotice) {
          this.$confirm("下次发布时将发送通知，您确定保存吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.cbAction(1);
          });
        } else {
          this.$confirm("下次发布时将无更新通知，您确定保存吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.cbAction(1);
          });
        }
      } else {
        //直接保存为草稿
        this.cbAction(1);
      }
    },

    /****
            根据手机号检索作者信息
            **/
    selectAuthor() {
      let phone = this.articleForm.phone;
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.articleForm.authorInfo = "";
        return false;
      }
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v1/operate/news/phone",
        body: JSON.stringify({
          phone: phone * 1,
        }),
      }).then((data) => {
        if (data.data.error == 10000) {
          this.articleForm.authorInfo = data.data.data.authorInfo;
          this.articleForm.authorUid = data.data.data.authorUid;
          this.articleForm.author = data.data.data.name;
        }
      });
    },
    // ************生成二维码
    qrcode(text) {
      let canvas = document.getElementById("canvas");

      QRCode.toCanvas(canvas, text, function (error) {
        //do nothing
      });
    },
    // ********预览
    preview() {
      let content = this.articleForm.content;
      if (!content) {
        return false;
      }
      content = this.cssString + content + this.cssStringEnd;
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v1/basicTools/upload/generateHtml",
        body: JSON.stringify({
          content: content,
          uploadImageType: 4,
        }),
      }).then((data) => {
        if (data.data.error == 10000) {
          let url = data.data.data;
          this.dialogFormVisible = true; //显示弹框
          this.qrcode(url);
        }
      });
    },
    /**
     * 添加文章
     * url /adminapi/v1/operate/news/add POST
     *
     * @param {String} title
     * @param {Number} categoryId
     * @param {String} content
     * @param {String} coverImage
     * @param {String} summary
     * @param {String} author
     * @param {Number} contentType
     * @param {Nmuber} articleStatus
     * @param {Number} publisherUid
     * @param {Number} createUid
     **/
    add(status) {
      let createUid = this.user.userId;
      let publisherUid = status === 1 ? 0 : createUid;
      let contentType = this.articleForm.containVideo === true ? 2 : 1;

      let phone = this.articleForm.phone;
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.$util.errorMsg("请正确填写作者手机号");
        return false;
      }
      this.articleForm.content =
        this.cssString + this.articleForm.content + this.cssStringEnd;

      let rootUnids = [],
        schObj = this.articleForm.schObj;
      if (schObj.applicableCampus == 0 && schObj.shieldedSchools.length) {
        for (let i = 0; i < schObj.shieldedSchools.length; i++) {
          rootUnids.push(schObj.shieldedSchools[i].rootUnid * 1);
        }
      } else if (schObj.applicableCampus == 1 && schObj.openedSchools.length) {
        for (let i = 0; i < schObj.openedSchools.length; i++) {
          rootUnids.push(schObj.openedSchools[i].rootUnid * 1);
        }
      }

      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v3/operate/news/add",
        body: JSON.stringify({
          createUid,
          publisherUid,
          contentType,
          title: this.articleForm.title,
          rootUnids,
          applicableCampus: schObj.applicableCampus * 1,
          coverImage: this.imgUrl,
          listImage: this.listImage,
          articleImages: [this.imgUrl],
          summary: this.articleForm.abstract,
          author: this.articleForm.author,
          categoryId: this.articleForm.type * 1,
          publishNum: Number(this.articleForm.ifNotice),
          content: this.articleForm.content,
          authorUid: this.articleForm.authorUid * 1,
          htmlUrl: this.articleForm.htmlUrl,
          articleStatus: status,
        }),
      }).then(
        (response) => {
          if (response.data.error === 10000) {
            location.href = "/#/yunying/article/articleManage";
          } else {
            this.$util.errorMsg(response.data.message);
          }
        },
        (response) => {
          this.$util.errorMsg("发布失败");
        }
      );
    },

    /**
     * 编辑文章
     * url /adminapi/v1/operate/news/add POST
     * @param {Number} newId
     * @param {String} title
     * @param {Number} categoryId
     * @param {String} content
     * @param {String} coverImage
     * @param {String} summary
     * @param {String} author
     * @param {Number} contentType
     * @param {Nmuber} articleStatus
     * @param {Number} publisherUid
     * @param {Number} createUid
     **/
    editNews(status) {
      let createUid = this.user.userId;
      let publisherUid = status === 1 ? 0 : createUid;
      let contentType = this.articleForm.containVideo === true ? 2 : 1;

      let phone = this.articleForm.phone;
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.$util.errorMsg("请正确填写作者手机号");
        return false;
      }
      this.articleForm.content =
        this.cssString + this.articleForm.content + this.cssStringEnd;

      let rootUnids = [],
        schObj = this.articleForm.schObj;
      if (schObj.applicableCampus == 0 && schObj.shieldedSchools.length) {
        for (let i = 0; i < schObj.shieldedSchools.length; i++) {
          rootUnids.push(schObj.shieldedSchools[i].rootUnid * 1);
        }
      } else if (schObj.applicableCampus == 1 && schObj.openedSchools.length) {
        for (let i = 0; i < schObj.openedSchools.length; i++) {
          rootUnids.push(schObj.openedSchools[i].rootUnid * 1);
        }
      }

      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v3/operate/news/editor",
        body: JSON.stringify({
          createUid,
          publisherUid,
          contentType,
          rootUnids,
          title: this.articleForm.title,
          applicableCampus: schObj.applicableCampus * 1,
          coverImage: this.imgUrl,
          listImage: this.listImage,
          articleImages: [this.imgUrl],
          summary: this.articleForm.abstract,
          author: this.articleForm.author,
          categoryId: this.articleForm.type * 1,
          publishNum: Number(this.articleForm.ifNotice),
          content: this.articleForm.content,
          authorUid: this.articleForm.authorUid * 1,
          htmlUrl: this.articleForm.htmlUrl,
          articleStatus: status,
          newsId: this.newsId,
        }),
      }).then(
        (response) => {
          if (response.data.error === 10000) {
            location.href = "/#/yunying/article/articleManage";
          } else {
            this.$util.errorMsg(response.data.message);
          }
        },
        (response) => {
          this.$util.errorMsg("编辑失败");
        }
      );
    },

    /**
     * 编辑获取文章详情
     * @param {Number} newsId
     **/
    getNewDetail(newsId) {
      this.$http({
        method: "POST",
        emulateJSON: true,
        url: this.$util.domain + "/adminapi/v3/operate/news/detail",
        body: { newsId },
      })
        .then(
          (responseData) => {
            if (responseData.data.error === 10000) {
              let response = responseData.data.data;

              let imgUrl = response.coverImage,
                listImage = response.listImage,
                title = response.title,
                abstract = response.summary,
                author = response.author,
                type = response.categoryId.toString(),
                content = response.content;

              this.imgUrl = imgUrl;
              this.listImage = listImage;
              this.articleForm.title = title;
              this.articleForm.abstract = abstract;
              this.articleForm.author = author;
              this.articleForm.type = type;
              this.articleForm.content = content;
              this.articleForm.authorUid = response.authorUid;
              this.articleForm.authorInfo = response.authorInfo;
              this.articleForm.phone = response.phone;
              this.articleForm.schObj.applicableCampus =
                response.applicableCampus + "";
              this.articleForm.htmlUrl = response.htmlUrl;

              response.applicableCampus == 0
                ? (this.articleForm.schObj.shieldedSchools =
                    response.campusList)
                : (this.articleForm.schObj.openedSchools = response.campusList);
              if (response.publisherUid) {
                this.articleForm.isPublished = true;
              }

              this.articleForm.containVideo =
                response.contentType === 2 ? true : false;
              this.articleForm.ifNotice =
                response.publishNum === 0 ? false : true;
            }
          },
          (response) => {
            this.$util.errorMsg(response.data.message);
          }
        )
        .catch((response) => {
          this.$util.errorMsg("请求失败");
        });
    },
    /**上传文件成功钩子**/
    handleSuccess(response) {
      if (response.error !== 10000) {
        this.$util.errorMsg("上传失败");
      } else {
        this.imgUrl = response.data;
      }
    },
    uploadSuccess(response) {
      if (response.error !== 10000) {
        this.$util.errorMsg("上传失败");
      } else {
        this.listImage = response.data;
      }
    },

    /**上传文件失败钩子**/
    handleError(response) {
      if (response.status === 403) {
        this.SIGNOUT();
        location.href = "/#";
      }

      this.$util.errorMsg("上传失败");
    },
  },
};
</script>
<style>
.articleTitle,
.articleAbstract,
.articleType {
  width: 80%;
}

.articleAuthor {
  width: 100%;
}

.articleContent {
  width: 98%;
}

.containVideo {
  position: absolute;
  top: 20px;
  left: 450px;
}

.ql-container {
  min-height: 400px;
}

#canvas {
  width: 200px !important;
  height: 200px !important;
}

.ql-video {
  width: 300px;
  height: 86px;
}

.gray {
  color: #999;
}
</style>



// WEBPACK FOOTER //
// about.vue?e989d17a